import 'starfish/starfishCommons.js';
import 'starfish/RowExpander.js';
import 'starfish/SFUtil.js';
import 'starfish/SFDate.js';
import 'starfish/SFAjax.js';
import 'starfish/SFWidget.js';
import 'starfish/SFForm.js';
import 'starfish/SFNav.js';
import 'starfish/Ext.BasicForm.bugfix.js';
import 'starfish/OOSubmit.js';
import 'starfish/SFArray.js';
import 'starfish/SFLanguage.js';
import 'starfish/SFPopup.js';
import 'starfish/SFRowExpander.js';
import 'starfish/SFSchedule.js';
import 'starfish/SFText.js';
import 'starfish/SFUrl.js';
import 'starfish/SFUser.js';
import 'starfish/Starfish.js';
import 'starfish/WorkspaceManager.js';
import 'starfish/accessibility.js';
import 'starfish/bundle.js';
import 'starfish/instructorDisplay.js';
import 'starfish/messages.js';
